import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export default function ProductDetailsSkeletonLoader() {
  return (
    <div className='mx-auto w-full max-w-screen-xl px-3 pt-8 md:px-20 md:pt-12 md:pb-20'>
      <div className='flex w-full flex-col gap-8 md:flex-row'>
        {/* Left side - Image carousel */}
        <aside className='w-full flex-shrink-0 md:w-[45%]'>
          <div className='xl:min-h-[100vh]'>
            {/* Main Image */}
            <div className='relative w-full overflow-hidden rounded-lg'>
              <Skeleton className='aspect-square w-full rounded-lg' />
            </div>

            {/* Thumbnail Navigation */}
            <div className='mt-3 hidden gap-4 overflow-x-auto px-2 py-2 md:flex'>
              {[1, 2, 3, 4].map((_, index) => (
                <Skeleton key={index} className='h-28 w-20 flex-shrink-0 rounded-lg' />
              ))}
            </div>

            {/* Desktop Description */}
            <div className='mt-8 hidden space-y-4 md:block'>
              <Skeleton className='h-6 w-40' />
              <Skeleton className='h-24 w-full' />
            </div>
          </div>
        </aside>

        {/* Right side - Product details */}
        <main className='divide-border-title/10 flex-1 divide-y-[1.5px]'>
          <div className='divide-border-title/10 h-fit divide-y-[1.5px] md:sticky md:top-28'>
            {/* Product Title and Price */}
            <div className='space-y-4 pb-4'>
              <Skeleton className='h-8 w-3/4' />
              <Skeleton className='h-6 w-1/3' />
              <Skeleton className='hidden h-20 w-full md:block' />
              <div className='block space-y-4 md:hidden'>
                <Skeleton className='h-6 w-40' />
                <Skeleton className='h-24 w-full' />
              </div>
            </div>

            {/* Style Options */}
            <div className='space-y-4 py-4'>
              <Skeleton className='h-12 w-full' />
              {/* Quantity and Add to Cart */}
              <div className='flex h-12 items-center gap-4'>
                <Skeleton className='h-full w-32 rounded-full' />
                <Skeleton className='h-full flex-1 rounded-lg' />
              </div>
            </div>

            {/* Product Meta Info */}
            <div className='flex flex-wrap gap-4 pt-5 pb-2'>
              {[1, 2, 3].map((_, index) => (
                <Skeleton key={index} className='h-4 w-24' />
              ))}
            </div>

            {/* Shipping Icons */}
            <div className='flex items-center justify-between py-4'>
              {[1, 2, 3].map((_, index) => (
                <div key={index} className='flex flex-col items-center gap-2'>
                  <Skeleton className='size-6' />
                  <Skeleton className='h-4 w-24' />
                </div>
              ))}
            </div>

            {/* Reviews Section */}
            <div className='flex flex-col gap-2 py-4'>
              <Skeleton className='h-4 w-64' />
              <Skeleton className='h-4 w-72' />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
